module.exports = __webpack_public_path__ + "img/lion.1fd33c10.png";